import axios from "axios";
import { IPerson } from "../models/IPerson";
import { SoknadClass } from "../models/SoknadClass";
import { IEmploymenttype } from "../models/IEmploymenttype";
import { IFylke } from "../models/IFylke";
import { AttachmentClass } from "../models/Attachment";
import { INote } from "../models/Note";


//const baseUrl = "http://localhost:5003"; //For debug use only
const baseUrl = "";

export async function getUser() {
  const result = await axios.get<IPerson>(
    `${baseUrl}/api/kvalitetsforbedringsarbeid/user`
  );
  return result.data;
}

export async function getUserInformation() {
  const result = await axios.get<any>(
    `${baseUrl}/api/kvalitetsforbedringsarbeid/user/information`
  );
  return result.data;
}

export async function getEmploymentsTypes() {
  const result = await axios.get<IEmploymenttype[]>(
    `${baseUrl}/api/ansettelse`
  );
  return result.data;
}

export async function getFylker() {
  const result = await axios.get<IFylke[]>(`${baseUrl}/api/fylker`);
  return result.data;
}
export async function getPoststed(postnummer: string) {
  const result = await axios.get<any>(
    `${baseUrl}/api/postnummer?postnummer=` + postnummer
  );
  return result.data.poststedNavn;
}

export async function uploadFileToServer(applicationId: any, formData: any) {
  return axios.post(
    `${baseUrl}/api/soknader/${applicationId}/attachments`,
    formData
  );
}

export async function getSoknader() {
  const result = await axios.get<SoknadClass[]>(`${baseUrl}/api/soknader`);
  return result.data;
}

export async function getVedlegg(id: any) {
  const result = await axios.get<AttachmentClass[]>(
    `${baseUrl}/api/kvalitetsforbedringsarbeid/Application/attachments/${id}`
  );
  return result.data;
}

export async function getNotes(applicationId: number) {
  const result = await axios.get<INote[]>(
    `${baseUrl}/api/Soknader/${applicationId}/notes`
  );
  return result.data;
}

export async function createNote(
  applicationId: number,
  subject: string,
  body: string
) {
  const result = await axios.post<INote>(
    `${baseUrl}/api/Soknader/${applicationId}/notes`,
    { subject: subject, body: body }
  );
  return result.data;
}

export async function downloadFile(applicationId: any, attachmentId: any) {
  const result = await axios.get(
    `${baseUrl}/api/kvalitetsforbedringsarbeid/Application/application/${applicationId}/attachment/${attachmentId}`,
    {
      responseType: "blob",
      headers: {
        "Content-Type": "application/octet-stream;charset=utf-8",
      },
    }
  );
  return result.data;
}

export async function deleteFile(applicationId: any, attachmentId: any) {
  console.log(`/api/Soknader/${applicationId}/attachment/${attachmentId}`);
  const result = await axios.delete<AttachmentClass[]>(
    `${baseUrl}/api/Soknader/${applicationId}/attachments/${attachmentId}`
  );
  return result.data;
}

export async function saveSoknad(application: SoknadClass, submit: boolean=false) {

  if (submit) {
    const result = await axios.patch<SoknadClass>(
        `${baseUrl}/api/soknader/submit`,
        application
    );
    return result.data;
  }

  const result = await axios.patch<SoknadClass>(
    `${baseUrl}/api/soknader`,
    application
  );
  return result.data;
}

export async function cancelSoknad(application: SoknadClass) {
  const result = await axios.get<SoknadClass>(
      `${baseUrl}/api/soknader/${application.id}/cancel`
  );
  return result.data;
}
